
export default{
    isLogin:function(_this){
        if(!_this.$store.getters.getLoginValue){
            return _this.$router.push("Login")
        }
    },

    /**
     * 将时间字符串转换为12小时制格式 (AM/PM)
     * @param {string} timeStr - 时间字符串，如 "2024-01-15 14:30:00" 或 "14:30:00"
     * @returns {string} - 12小时制格式，如 "2024-01-15 02:30:00 PM" 或 "02:30:00 PM"
     */
    formatTime12Hour: function(timeStr) {
        if (!timeStr) return '-';

        // 匹配时间部分 HH:mm:ss 或 HH:mm
        const timeMatch = timeStr.match(/(\d{1,2}):(\d{2})(?::(\d{2}))?/);
        if (!timeMatch) return timeStr;

        let hours = parseInt(timeMatch[1], 10);
        const minutes = timeMatch[2];
        const seconds = timeMatch[3] || '';

        const period = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // 0点转为12点
        const hours12 = hours.toString().padStart(2, '0');

        const timePart = seconds
            ? `${hours12}:${minutes}:${seconds} ${period}`
            : `${hours12}:${minutes} ${period}`;

        // 替换原时间字符串中的时间部分
        return timeStr.replace(/\d{1,2}:\d{2}(:\d{2})?/, timePart);
    }
}
